export const global = {
  // UAT URL
  base_url: "https://test.takafulbruneidownloads.com",
  base_url2: "https://lpsdev.takafulbruneidownloads.com",

  // Production URL
  // base_url: "https://loadbalancer.takafulbruneidownloads.com",
  // base_url2: "https://lpsbackend.takafulbruneidownloads.com",
  
  // Local URL
  // base_url: "https://tbdbackend.test",
  // base_url2: "https://lpsbackend.test",

  // Pre Production URL
  // base_url: "https://tbd-uat.takafulbruneidownloads.com",
  // base_url2: 'https://lpsuat.takafulbruneidownloads.com',


  get url() {
    return this.base_url + "/api";
  },
  get url2() {
    return this.base_url + "/apiv2";
  },
  get lps_url() {
    return this.base_url2 + "/api";
  },

  get app_version() {
    return "6.3.0 (UAT)";
  },
};

export const lps = () => {
  return "Loyalty Point System";
};
